import axios from 'axios';

export function resolveApiErrorMessage(caughtError: unknown): string {
  if (axios.isAxiosError(caughtError) === false) {
    return '';
  }
  if (caughtError.response === undefined) {
    return '';
  }
  const responseData = caughtError.response.data;
  if (responseData === null || typeof responseData !== 'object') {
    return '';
  }
  const backendMessage = (responseData as Record<string, unknown>).message;
  if (typeof backendMessage === 'string' && backendMessage.length > 0) {
    return backendMessage;
  }
  return '';
}
